module.exports = __webpack_public_path__ + "img/footer-linkedin.da024d93.svg";